import { domGetAttr } from "../utils/dom";
import { processElementEvent } from "../events/element";
import { domEventTypes } from "../types/dom-events";
export const handleClick = (event) => {
    const domAttr = domGetAttr(event);
    processElementEvent(domAttr, domEventTypes.click);
};



//////////////////
// WEBPACK FOOTER
// ./~/@celine/passive-tracking/dist/element-handlers/click.js
// module id = ./node_modules/@celine/passive-tracking/dist/element-handlers/click.js
// module chunks = 0